
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Form } from 'element-ui';
import moment from 'moment';
@Component({
  filters: {
    yyyy_mm_dd_two(val: number) {
      return moment(val * 1000).format('YYYY/MM/DD HH:mm:ss');
    },
  },
})
export default class extends Vue {
  @Prop() detailsDialog!: boolean;
  @Prop() messageDetails!: any;
  @Prop() getUserId!: Function;
  handleClose() {
    this.$emit('update:detailsDialog', false);
  }
}
